
function FormTitle(){
    return(
        <>
             <h1 className='form-title'>
                Formulário de Contato <br />
             </h1>
             <p className='form-content-text'>Estou aguardando sua mensagem!</p>
        </>
    )
}

export default FormTitle;